export default __webpack_public_path__ + "static/assets/93babda8f98fc8009c28e97f1f118b6f.png";